import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full bg-gradient-to-b from-black to-gray-800 p-4 pt-40 text-white"
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full text-left">
        <div className="flex flex-col justify-center items-center">
          <p className="text-4xl font-bold border-b-4 border-gray-500">
            Contact
          </p>
          <p className="py-4">Fill out the form below to connect with me!</p>
          <form
            className="flex flex-col w-full md:w-1/2"
            action="https://getform.io/f/318c3b94-cf7f-4c47-b087-326430140345"
            method="POST"
          >
            <input
              type="text"
              name="name"
              placeholder="Your name"
              className="my-2 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="text"
              name="email"
              placeholder="Your email address"
              className="my-2 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="10"
              className="my-2 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            ></textarea>
            <button className="text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
